const NewDesign = [
    // {
    //     path: '/repaymentNote',
    //     name: 'repaymentNote',
    //     component: () => import('../views/newDesign/repaymentNote.vue'),
    //     meta: {
    //         'title': 'Repayment Note'
    //     }
    // },
    {
        path: '/lucky',
        name: 'mlucky',
        component: () => import('../views/newDesign/mlucky.vue'),
        meta: {
            'title': 'Lucky draw'
        }
    },
    {
        path: '/couponGuide',
        name: 'couponGuide',
        component: () => import('../views/newDesign/couponGuide.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    {
        path: '/dnload',
        name: 'dnload',
        component: () => import('../views/newDesign/deeplink.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    // refused to other - v1
    {
        path: '/loanMkt1',
        name: 'loanMarket',
        component: () => import('../views/newDesign/loanMarket.vue'),
        meta: {
            'title': 'OKash Loan'
        }
    },
    // refused to other - v2
    {
        path: '/loanMkt',
        name: 'loanMarket',
        component: () => import('../views/newDesign/loanMarket-2.vue'),
        meta: {
            'title': 'OKash Loan'
        }
    }
]

export default NewDesign



// WEBPACK FOOTER //
// ./src/router/newDesign.js